const env = { API_URL: 'https://qa.api.cohortai.com/crud' } ;
export default env
